import { render } from "./ModalResendEmail.vue?vue&type=template&id=4eff7ea9"
import script from "./ModalResendEmail.vue?vue&type=script&lang=ts"
export * from "./ModalResendEmail.vue?vue&type=script&lang=ts"
script.render = render

export default script